import React from 'react'
import { PrismicRichText } from '@prismicio/react'

const BodyWrap = ({ body }) => {
  return <PrismicRichText field={body.richText} />
}

export default BodyWrap
